var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSearchResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "68px",
    viewBox: "0 0 54 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Empty State - No search results (small)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.2858894%",
    y1: "61.5718463%",
    x2: "62.6988134%",
    y2: "38.1085239%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EA6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71A8FF",
    offset: "36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BAEFF",
    offset: "63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BB9FF",
    offset: "87%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C1FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "25.7478152%",
    y1: "71.6906227%",
    x2: "74.3596003%",
    y2: "28.4073987%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696",
    offset: "22%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8E8E",
    offset: "49%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "76.1449275%",
    y1: "63.7131191%",
    x2: "167.556522%",
    y2: "39.3705188%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696",
    offset: "22%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8E8E",
    offset: "49%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.59418091%",
    y1: "46.7673184%",
    x2: "99.4199124%",
    y2: "51.1527366%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.7565762%",
    y1: "45.9898771%",
    x2: "41.2565762%",
    y2: "55.5161566%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4F4F",
    offset: "42%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F6F6F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7870.97264%",
    y1: "3685.03892%",
    x2: "7828.81459%",
    y2: "3648.08407%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4F4F",
    offset: "42%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F6F6F",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-States",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-pattern-/-No-search-results-(available-in-other-Org)",
    transform: "translate(-571.000000, -525.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empty-State---No-search-results-(small)",
    transform: "translate(571.000000, 525.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C9DEFF",
    points: "46.06 47.92 34.84 41.42 23.61 47.92 34.84 54.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C9DEFF",
    points: "48.47 46.53 34.84 38.64 21.21 46.53 34.84 54.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6EA6FF",
    points: "46.06 60.9 46.06 47.96 34.84 54.46 34.84 67.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#97C1FF",
    points: "34.84 67.4 34.84 54.46 23.61 47.96 23.61 60.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.26,27.63 L17.26,27.63 C18.2676461,28.7094759 19.8241276,29.0798791 21.21,28.57 C23.76,27.87 25.82,25.42 25.82,23.11 C25.8326966,22.326571 25.5383875,21.5692636 25,21 L9,2 L9,2 C8.0037347,0.868302965 6.41162092,0.47027452 5,1 C2.46,1.7 0.39,4.15 0.39,6.46 C0.376065231,7.11269595 0.568545809,7.75313133 0.94,8.29 L0.94,8.29 L1.22,8.62 L17.26,27.63 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#C9DEFF",
    transform: "translate(21.210248, 24.379307) rotate(-40.020000) translate(-21.210248, -24.379307) ",
    cx: 21.2102476,
    cy: 24.379307,
    rx: 5.11,
    ry: 3.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.35,31.25 L22.35,31.25 C23.0212389,31.9752137 24.0636166,32.223963 24.99,31.88 C26.6845525,31.4270427 27.9176216,29.9665142 28.08,28.22 C28.0991214,27.6872128 27.9047324,27.168842 27.54,26.78 L24.12,22.54 L24.12,22.54 C23.456029,21.7698155 22.3827142,21.4945043 21.43,21.85 C19.7338974,22.3068152 18.5012184,23.7708709 18.34,25.52 C18.3309902,25.9541046 18.4567614,26.3803294 18.7,26.74 L18.7,26.74 L18.88,26.96 L22.35,31.25 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-3)",
    transform: "translate(25.429436, 29.433006) rotate(-40.020000) translate(-25.429436, -29.433006) ",
    cx: 25.4294357,
    cy: 29.4330061,
    rx: 3.45,
    ry: 2.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.12,41.85 C13.73,37.56 13.77,30.6 21.21,26.3 C28.65,22 40.66,22 48,26.31 C55.34,30.62 55.39,37.56 48,41.85 C40.61,46.14 28.51,46.14 21.12,41.85 Z M23,27.33 C16.56,31.05 16.53,37.1 22.92,40.82 C29.31,44.54 39.77,44.54 46.2,40.82 C52.63,37.1 52.68,31.05 46.28,27.34 C39.88,23.63 29.44,23.62 23,27.34",
    id: "Shape",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,49.61 C51.61,47.53 53.47,44.81 53.58,42.07 L53.58,42.07 L53.58,41.72 L53.58,34.04 C53.5487551,35.4257287 53.1181886,36.7729852 52.34,37.92 C51.2168798,39.5351255 49.7303507,40.8640963 48,41.8 L47.58,42.04 C40.17,46.04 28.58,46.04 21.29,41.88 L21.16,41.8 C19.4552193,40.8823612 17.9866881,39.5815643 16.87,38 C16.0928632,36.8499664 15.6688103,35.4978635 15.65,34.11 L15.65,41.89 C15.65,44.71 17.47,47.52 21.15,49.66 C28.51,53.9 40.55,53.9 48,49.61 Z",
    id: "Path",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,42 L51,41.88 C51.0049165,41.9198489 51.0049165,41.9601511 51,42 Z",
    id: "Path",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.89,35.09 C23.6692957,34.6448898 24.481695,34.260421 25.32,33.94 C31.2049885,31.7890585 37.6563704,31.7607629 43.56,33.86 C44.4617144,34.1990197 45.3345556,34.6103586 46.17,35.09 C47.486311,35.8231865 48.6423934,36.8126571 49.57,38 C50.431812,36.9407291 50.9328162,35.6339138 51,34.27 L51,33.82 L51,33.82 C50.9,31.47 49.32,29.13 46.23,27.34 C39.83,23.62 29.39,23.62 22.95,27.34 C19.78,29.17 18.16,31.57 18.1,33.98 L18.1,33.98 L18.1,34.11 C18.1258237,35.502082 18.6070348,36.8473655 19.47,37.94 C20.416022,36.7788148 21.5772564,35.8111194 22.89,35.09 L22.89,35.09 Z",
    id: "Path",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.18,40.82 C52.62,37.1 52.66,31.05 46.26,27.34 C39.86,23.63 29.42,23.62 22.98,27.34 C16.54,31.06 16.51,37.11 22.9,40.83 C29.29,44.55 39.75,44.54 46.18,40.82 Z",
    id: "Path",
    fill: "#004CC5",
    opacity: 0.25
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResults);
export default __webpack_public_path__ + "static/media/no_search_results.bf8ef24c58a9a5524ef96241343eadc5.svg";
export { ForwardRef as ReactComponent };